function n(l) {
  return l == null;
}
export {
  n as default,
  n as isNil
};
